// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"N0-z"};